const ru = {

    /* Language */
    "lang.ru": "RU",
    "lang.en": "EN",

    /* Menu */
    "menu.dashboard": "Dashboard",
    "menu.game": "Игры",
    "menu.player": "Игроки",
    "menu.studio": "Студии",
    "menu.bonus": "Бонус",
    "menu.message": "Сообщение",
    "menu.currency": "Валюты",
    "menu.card": "Карты",
    "menu.dealer": "Дилера",
    "menu.users": "Пользователи",
    "menu.operators": "Операторы",
    "menu.roles": "Роли",

    /* Header */
    "header.profile": "Профиль",
    "header.changePassword": "Изменить пароль",
    "header.history": "История входа",
    "header.logout": "Выйти",

    /* Auth */
    "auth.title": "Панель управления",
    "auth.password": "Пароль",
    "auth.login": "Войти",
    "auth.error.emptyEmail": "Введите Email",
    "auth.error.invalidEmail": "Неверный формат Email",
    "auth.error.emptyPassword": "Введите пароль",
    "auth.error.shortPassword": "Пароль должен быть больше 8 символов",
    "auth.error.invalidCredentials": "Данные неверные!",
    "auth.error.userNotFound": "Пользователь не найден!",
    "auth.error.wrongPassword": "Неверный пароль!",
    "auth.error.tooManyAttempts": "Множество попыток входа! Попробуйте позднее.",
    "auth.error.generic": "Что-то пошло не так! Попробуйте позднее.",

    /* Layout (full-page states) */
    "layout.serverError": "Ошибка сервера!",
    "layout.serverErrorDesc": "Что-то пошло не так! Попробуйте позднее.",
    "layout.networkError": "Ошибка соединения!",
    "layout.networkErrorDesc": "Проверьте подключение к сети.",
    "layout.noAccess": "Нет доступа!",
    "layout.noAccessDesc": "У вас нет доступа для просмотра данных.",
    "layout.invalidKey": "Неверный ключ!",
    "layout.invalidKeyDesc": "Похоже ключ устарел! Перезагрузите страницу или войдите в свой аккаунт еще раз.",
    "layout.retry": "Повторить",
    "layout.reload": "Перезагрузить",
    "layout.empty": "Ничего не найдено!",
    "layout.emptyDesc": "Попробуйте еще раз изменив фильтры.",

    /* Notes */
    "notes.empty": "Нет заметок",
    "notes.title": "Заметки",
    "notes.createError": "Не удалось создать заметку!",
    "notes.placeholder": "Напишите текст",

    /* DateFilter */
    "filter.selectDate": "Выберите дату",
    "filter.selectDates": "Выберите даты",
    "filter.cancel": "Отменить",
    "filter.apply": "Применить",
    "filter.operators": "Операторы",

    /* Pagination */
    "pagination.showing": "Показано",
    "pagination.of": "из",

    /* Cards */
    "cards.empty": "Пусто",

    /* Transaction */
    "transaction.title": "Информация о транзакции",
    "transaction.number": "Номер транзакции",
    "transaction.player": "Игрок",
    "transaction.name": "Название",
    "transaction.type": "Тип",
    "transaction.time": "Время",
    "transaction.amount": "Сумма",
    "transaction.status": "Статус",
    "transaction.success": "Успешно",
    "transaction.error": "Ошибка",
    "transaction.result": "Результат",

    /* Time */
    "time.today": "Сегодня",
    "time.todayComma": "Сегодня, ",
    "time.yesterday": "Вчера",
    "time.yesterdayComma": "Вчера, ",
    "time.allTime": "За все время",

    /* Days of week */
    "days.monday": "Понедельник",
    "days.tuesday": "Вторник",
    "days.wednesday": "Среда",
    "days.thursday": "Четверг",
    "days.friday": "Пятница",
    "days.saturday": "Суббота",
    "days.sunday": "Воскресенье",

    /* Permission */
    "permission.one": "доступ",
    "permission.few": "доступа",
    "permission.many": "доступов",

    /* Common */
    "common.add": "Добавить",
    "common.delete": "Удалить",
    "common.edit": "Редактировать",
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.yes": "Да",
    "common.no": "Нет",
    "common.name": "Название",
    "common.view": "Посмотреть",
    "common.enabled": "Включен",
    "common.disabled": "Отключен",
    "common.selectAll": "Выбрать все",
    "common.clearAll": "Отменить все",
    "common.generatePassword": "Сгенерировать пароль",
    "common.send": "Отправить",

    /* Common swal */
    "swal.deleteConfirm": "Вы действительно хотите удалить?",
    "swal.deleteWarning": "Невозможно восстановить после удаления",
    "swal.deleteButton": "Удалить!",
    "swal.cancelButton": "Отмена",
    "swal.noAccess": "Нет доступа!",
    "swal.invalidKey": "Неверный ключ!",
    "swal.generic": "Что-по пошло не так! <br /> Попробуйте позднее.",
    "swal.savedSuccess": "Данные успешно сохранены!",
    "swal.deleteGame": "Удалить игру?",
    "swal.deleteGameWarning": "После удаления восстановить невозможно.",
    "swal.cancelButton2": "Отменить",
    "swal.gameDeleted": "Игра удалена!",
    "swal.settingsSaved": "Данные успешно сохранены! <br /> Изменения появятся<br /> после обновления страницы.",

    /* Settings widget */
    "settings.tableName": "Название стола",
    "settings.tableKey": "Ключ стола",
    "settings.gameLabel": "Игра",
    "settings.gameURL": "URL игры",
    "settings.serverURL": "URL сервера",
    "settings.type": "Тип",
    "settings.image": "Изображение",
    "settings.currentDealer": "Текущий Дилер",
    "settings.enterName": "Введите название стола",
    "settings.enterKey": "Введите ключ стола",
    "settings.enterGame": "Введите название игры",
    "settings.tokenCopied": "Токен успешно скопирован!",
    "settings.save": "Сохранить",

    /* Dashboard */
    "dashboard.filterAll": "За все время",
    "dashboard.filterToday": "За сегодня",
    "dashboard.filterWeek": "За неделю",
    "dashboard.filterMonth": "За месяц",
    "dashboard.filterYear": "За год",
    "dashboard.filterPeriod": "Период",
    "dashboard.hello": "Привет,",
    "dashboard.profit": "Прибыль (GGR)",
    "dashboard.visitors": "Посетители",
    "dashboard.players": "Игроки",
    "dashboard.rounds": "Раунды",
    "dashboard.games": "Игры",
    "dashboard.notes": "Заметки",
    "dashboard.activity": "Активность",
    "dashboard.transactions": "Транзакции",
    "dashboard.gamesReport": "Отчет по играм",
    "dashboard.reportGameName": "Название игры",
    "dashboard.reportPlayers": "Количество игроков",
    "dashboard.reportRounds": "Количество раундов",
    "dashboard.reportDebit": "Ставка (DEBIT)",
    "dashboard.reportCredit": "Выплата (CREDIT)",
    "dashboard.reportTotal": "Итого",
    "dashboard.reportSheet": "Отчет по играм",
    "dashboard.playersWord1": "игрок",
    "dashboard.playersWord24": "игрока",
    "dashboard.playersWord5": "игроков",

    /* Game pages */
    "game.title": "Игры",
    "game.add": "Добавить",
    "game.statistics": "Статистика",
    "game.currencies": "Валюты",
    "game.settings": "Настройки",
    "game.parameters": "Параметры",
    "game.writeMessage": "Написать сообщение",
    "game.dealers": "Дилеры",
    "game.gameNumber": "Игра #",
    "game.connectionOk": "Соединение установлено",
    "game.connectionFail": "Соединение прервано",
    "game.connecting": "Соединение ...",
    "game.videoArchive": "Видео архив",
    "game.addTitle": "Добавить игру",
    "game.tableName": "Название стола",
    "game.tableKey": "Ключ стола",
    "game.gameURL": "URL игры",
    "game.serverURL": "URL сервера",
    "game.tableStatuses": "Статусы стола:",
    "game.tableVisibility": "Видимость стола",
    "game.selectGame": "Выберите игру",
    "game.error.emptyName": "Введите название cтола",
    "game.error.emptyKey": "Введите ключ cтола",
    "game.error.invalidKey": "Недопустимое значение",
    "game.error.selectGame": "Выберите игру",
    "game.addedSuccess": "Игра успешно добавлена",

    /* Electron game widget - games list */
    "widget.searchByNumber": "Поиск по номеру игры",
    "widget.playerID": "ID игрока",
    "widget.to": "до",
    "widget.gameNumber": "Номер игры",
    "widget.dealer": "Дилер",
    "widget.players": "Игроки",
    "widget.status": "Статус",
    "widget.date": "Дата",
    "widget.operator": "Оператор",
    "widget.winNumber": "Выигрышный номер",
    "widget.paused": "На паузе",
    "widget.completed": "Завершен",
    "widget.notCompleted": "Не завершен",

    /* Game info widget */
    "widget.finishConfirm": "Вы действительно хотите завершить игру?",
    "widget.finishWarning": "Невозможно восстановить после изменений",
    "widget.finishButton": "Да, завершить",
    "widget.finishSuccess": "Игра завершена успешно!",
    "widget.finishDone": "Завершение выполнено!",
    "widget.alreadyFinished": "Игра уже завершена!",
    "widget.unknownError": "Неизвестная ошибка! Пожалуйста, повторите попытку позже.",
    "widget.gamePaused": "Игра на паузе!",
    "widget.finishConfirmAlt": "Вы действительно завершить игру?",
    "widget.finishWarningAlt": "Невозможно восстановить после завершения",

    /* VipGame game info */
    "widget.game": "Игра",
    "widget.gameStatus": "Статус игры",
    "widget.pauseStatus": "Статус паузы",
    "widget.changeStatus": "Статус изменении",
    "widget.changed": "Изменен",
    "widget.player": "Игрок",
    "widget.total": "Итого",
    "widget.balanceBefore": "Баланс до игры",
    "widget.balanceAfter": "Баланс после игры",
    "widget.finishGame": "Завершить игру",
    "widget.finishAndRefund": "Завершить и вернуть ставку",
    "widget.pauseGame": "Приостановить игру",
    "widget.resetCards": "Сбросить карты",
    "widget.continueWithout": "Продолжить без изменении",
    "widget.pauseConfirm": "Вы действительно хотите сделать паузу?",
    "widget.pauseWarning": "Игра будет приостановлена",
    "widget.pauseButton": "Да, приостановить",
    "widget.alreadyPaused": "Игра уже на паузе!",
    "widget.gameFinished": "Игра завершена!",
    "widget.warningStatusDb": "Внимание! Статус изменен только<br /> в базе данных, так как<br /> эта не текущая игра!",
    "widget.finishTxError": "Игра завершена! Не удалось завершить транзакцию!",

    /* Refund */
    "widget.refundTitle": "Возврат ставки",
    "widget.payTitle": "Оплата суммы",
    "widget.totalBet": "Общая ставка",
    "widget.refunded": "Возвращено",
    "widget.paid": "Оплачено",
    "widget.enterAmount": "Введите сумму",
    "widget.pay": "Оплатить",
    "widget.amountError": "Введите сумму",
    "widget.refundSuccess": "Возврат успешно завершен",
    "widget.paySuccess": "Оплата успешно завершена",
    "widget.refundTitle2": "Возврат средств: ",
    "widget.payTitle2": "Пополнение суммы: ",
    "widget.balance": "Баланс",
    "widget.playerInfo": "Информация о игроке",
    "widget.rouletteNumber": "Номер",
    "widget.rouletteBet": "Ставка",
    "widget.rouletteWin": "Выигрыш",
    "widget.somethingWrong": "Что-то пошло не так! Попробуйте позднее!",

    /* Statistics widget */
    "stats.players": "Количество Игроков",
    "stats.anteBets": "Количество ставок ANTE",
    "stats.totalTime": "Общее время",
    "stats.profit": "ПРИБЫЛЬ:",
    "stats.avgAnte": "Средняя ставка ANTE",
    "stats.combinations": "Комбинации",
    "stats.period": "Статистика за период",
    "stats.day": "День",
    "stats.week": "Неделя",
    "stats.month": "Месяц",
    "stats.statsFor": "Статистика за",
    "stats.testerWarning": "Внимание! Статистика не включает данные тестировщиков!",
    "widget.from": "с",

    /* Table Control widget */
    "control.bridgeConnected": "Подключено к Bridge",
    "control.bridgeError": "Ошибка Bridge",
    "control.noGameConnection": "Нет подключение с игрой!",
    "control.enterTime": "Введите время",
    "control.tableVisibility": "Видимость стола",
    "control.makePublicHidden": "Сделайте стол публичным или скрытым",
    "control.tableFree": "Стол свободен",
    "control.tableBusy": "Стол занят",
    "control.autoDetect": "Определяется автоматически",
    "control.tableAccess": "Доступ к столу (открыть/закрыть смену)",
    "control.allowDeny": "Разрешить или запретить вход на стол",
    "control.tableClosed": "Cтол закрыт",
    "control.tableOpen": "Cтол работает",
    "control.allDay": "Круглосуточно",
    "control.allDayWork": "Круглосуточная работа",
    "control.workStart": "Время начала работы",
    "control.workEnd": "Время окончания работы",

    /* Table Refunds widget */
    "refund.transactionNumber": "Номер транзакции",
    "refund.name": "Название",
    "refund.amount": "Сумма",
    "refund.amountUSD": "Сумма (USD)",
    "refund.admin": "Админ",
    "refund.dateTime": "Дата и время",
    "refund.success": "Успешно",
    "refund.error": "Ошибка",
    "refund.title": "Возвраты",

    /* VipGame/MultiGame specific */
    "widget.finishConfirmBtn": "Завершить",
    "widget.gamePausedSuccess": "Игра на паузе",
    "widget.gameNotPaused": "Игра не на паузе!",
    "widget.continueConfirm": "Вы действительно хотите продолжить?",
    "widget.continueText": "Игра будет продолжаться без изменении",
    "widget.gameContinued": "Игра продолжается",
    "widget.resetCardsText": "Карты будут сброшены",
    "widget.cardsReset": "Карты сброшены",
    "widget.refundAllConfirm": "Вы действительно хотите возвращать ставку всем?",
    "widget.refundAllWarning": "Операцию отменить нельзя",
    "widget.refundAllBtn": "Да, возвращать",
    "widget.refundsComplete": "Возвраты выполнены!",
    "widget.searchByPlayerNumber": "Поиск по номеру игрока",
    "widget.gameNumber2": "Номер игры",
    "widget.empty": "Пусто",
    "widget.playersCount": "Количество игроков",
    "widget.transactionCount": "Количество транзакции",
    "widget.allRefunds": "Все возвраты",
    "widget.refundAllBets": "Вернуть ставку всем",
    "widget.refundAllBetsAndPay": "Вернуть все ставки и оплаты",
    "widget.continueGame": "Продолжить игру",
    "widget.refundAndPayAllConfirm": "Вы действительно хотите возвращать ставку и оплату всем?",
    "widget.allRefundsComplete": "Все возвраты выполнены!",
    "widget.operationConfirm": "Вы действительно хотите выполнить операцию?",

    /* Studio Room */
    "studio.participantsTitle": "Участники",
    "studio.nameLabel2": "Имя",
    "studio.disconnectStream": "Отключить стрим",

    /* Bonus Jackpot Connect/Update */
    "bonus.selectOperator": "Выберите оператора",
    "bonus.cashLabel": "Касса, $",
    "bonus.visibility": "Видимость",
    "bonus.connect2": "Соединить",
    "bonus.connectJackpotTitle": "Подключить JACKPOT",
    "bonus.send": "Отправить",


    /* Player widget */
    "player.information": "Общая\u0020информация",
    "player.sessions": "Сессии",
    "player.filter": "Фильтр",
    "player.operators": "Операторы",
    "player.selectOperator": "Выберите минимум 1 оператора",
    "player.selectDates": "Выберите даты",
    "player.last3h": "Последних 3 часа",
    "player.last6h": "Последних 6 часов",
    "player.last12h": "Последних 12 часов",
    "player.today": "Сегодня",
    "player.yesterday": "Вчера",
    "player.last7days": "Последних 7 дней",
    "player.last14days": "Последних 14 дней",
    "player.last30days": "Последних 30 дней",
    "player.thisMonth": "Этот месяц",
    "player.prevMonth": "Предыдущий месяц",
    "player.allTime": "За все время",
    "player.tester": "Тестировщик",
    "player.player": "Игрок",
    "player.operator": "Оператор",
    "player.rounds": "Количество раундов",
    "player.avgBet": "Средняя ставка",
    "player.totalTime": "Общее время",
    "player.selectPeriod": "Выберите период",
    "player.statsAll": "За\u00A0все\u00A0время",
    "player.statsDay": "День",
    "player.statsWeek": "Неделя",
    "player.statsMonth": "Месяц",
    "player.statsPeriod": "Период",
    "player.roundCount": "Количество раундов",
    "player.report": "Отчет по игрокам",
    "player.reportName": "Имя игрока",
    "player.reportCode": "Код игрока",
    "player.reportLastGame": "Последняя игра",
    "player.reportOperator": "Оператор",
    "player.reportCurrency": "Валюта",
    "player.reportLastSession": "Последняя сессия",
    "player.reportSheet": "Отчет по игрокам",
    "player.title": "Игроки",
    "player.lastGame": "Последняя игра",
    "player.currency": "Валюта",
    "player.dateTime": "Дата и время",
    "player.statsTitle": "Статистика игрока",
    "player.isTester": "Тестировщик",
    "player.viewStats": "Посмотреть статистику",
    "player.setTester": "Отметить как тестировщика",
    "player.removeTester": "Убрать статус тестировщика",
    "player.search": "Поиск по имени и коду",
    "player.filterPeriod": "Период",
    "player.changeConfirm": "Вы действительно хотите поменять?",
    "player.changeWarning": "Эта влияет на статистику",
    "player.statusChanged": "Статус успешно изменен",

    /* Admin pages */
    "admin.title": "Пользователи",
    "admin.activity": "Активность",
    "admin.history": "История входа",
    "admin.changeAccess": "Изменить доступы",
    "admin.edit": "Редактировать",
    "admin.changePassword": "Изменить пароль",
    "admin.delete": "Удалить",
    "admin.name": "Имя",
    "admin.role": "Роль",
    "admin.extendedAccess": "Расширенный доступ",
    "admin.createTitle": "Создать пользователя",
    "admin.editTitle": "Редактировать пользователя",
    "admin.teamName": "Названия команды",
    "admin.selectRole": "Выберите роль",
    "admin.addedSuccess": "Пользователь успешно добавлен",
    "admin.deletedSuccess": "Пользователь успешно удален",
    "admin.error.emptyName": "Введите свое имя",
    "admin.error.emptyEmail": "Введите Email",
    "admin.error.emptyTeam": "Введите названия команды",
    "admin.error.invalidEmail": "Неверный формат Email",
    "admin.error.emptyPassword": "Введите пароль",
    "admin.error.shortPassword": "Пароль должен быть больше 8 символов",
    "admin.error.selectRole": "Выберите роль",
    "admin.passwordSaved": "Пароль успешно сохранен",
    "admin.historyTitle": "История входа",
    "admin.activityTitle": "Активность",
    "admin.changeAccessTitle": "Изменить доступы",
    "admin.newPassword": "Новый пароль",
    "admin.repeatNewPassword": "Повторите новый пароль",
    "admin.device": "Устройство",
    "admin.browser": "Браузер",
    "admin.ip": "IP адрес",
    "admin.country": "Страна, Город",
    "admin.lastActivity": "Последняя активность",
    "admin.game": "Игра",
    "admin.action": "Действие",
    "admin.dateTime": "Дата и время",
    "admin.general": "Общий",

    /* Profile pages */
    "profile.title": "Профиль",
    "profile.image": "Изображение",
    "profile.name": "Имя",
    "profile.save": "Сохранить",
    "profile.savedSuccess": "Данные успешно сохранены",
    "profile.imageSaved": "Изображение успешно сохранено",
    "profile.imageDeleted": "Изображение успешно удалено",
    "profile.error.emptyName": "Введите имя",
    "profile.changePassword": "Изменить пароль",
    "profile.currentPassword": "Текущий пароль",
    "profile.newPassword": "Новый пароль",
    "profile.repeatPassword": "Повторите пароль",
    "profile.error.emptyCurrentPwd": "Введите текущий пароль",
    "profile.error.shortCurrentPwd": "Пароль должен быть больше 8 символов",
    "profile.error.emptyNewPwd": "Введите новый пароль",
    "profile.error.shortNewPwd": "Пароль должен быть больше 8 символов",
    "profile.error.mismatch": "Пароли не совпадают",
    "profile.passwordChanged": "Пароль успешно изменен!",
    "profile.error.wrongPassword": "Неверный пароль!",
    "profile.error.authError": "Ошибка авторизации!",
    "profile.historyTitle": "История входа",
    "profile.device": "Устройство",
    "profile.browser": "Браузер",
    "profile.ipAddress": "IP адрес",
    "profile.countryCity": "Страна, Город",
    "profile.lastActivity": "Последняя активность",

    /* Page 404 */
    "page404.text": "Страница, которую вы запрашивали, не существует.",

    /* Dealer pages */
    "dealer.title": "Дилерa",
    "dealer.add": "Добавить",
    "dealer.name": "Имя",
    "dealer.gamesCount": "Количество игр",
    "dealer.qrCode": "QR код",
    "dealer.downloadPng": "Скачать .PNG",
    "dealer.edit": "Редактировать",
    "dealer.delete": "Удалить",
    "dealer.addTitle": "Добавить дилера",
    "dealer.editTitle": "Изменить данные",
    "dealer.dealerName": "Имя дилера",
    "dealer.error.emptyName": "Введите имя дилера",
    "dealer.error.emptyPin": "Введите PIN/Barcode",
    "dealer.error.pinLength": "Длина PIN/штрих-кода должна быть 6 символов",
    "dealer.addedSuccess": "Дилер успешно добавлен",
    "dealer.savedSuccess": "Дилер успешно сохранен",
    "dealer.deletedSuccess": "Дилер успешно удален",
    "dealer.added": "Дилер добавлен",
    "dealer.removed": "Дилер убран",

    /* Currency pages */
    "currency.title": "Валюты",
    "currency.name": "Название",
    "currency.code": "Код",
    "currency.symbol": "Символ",
    "currency.add": "Добавить",
    "currency.edit": "Редактировать",
    "currency.delete": "Удалить",
    "currency.addTitle": "Добавить валюту",
    "currency.editTitle": "Редактировать валюту",
    "currency.symbolBefore": "Ставить символ перед цифрой",
    "currency.error.emptyName": "Введите название валюты",
    "currency.error.emptyCode": "Введите код валюты",
    "currency.error.codeLength": "Длина кода должна быть 3 символа",
    "currency.error.emptySymbol": "Введите символ валюты",
    "currency.addedSuccess": "Валюта успешно добавлена",
    "currency.savedSuccess": "Валюта успешно cохранена",
    "currency.deletedSuccess": "Валюта успешно удалена",
    "currency.alreadyAdded": "Валюта уже добавлена",
    "currency.selectCurrency": "Выберите валюту",
    "currency.maxBet": "Максимальная ставка",
    "currency.maxBonusBet": "Максимальная ставка для бонуса",
    "currency.minBet": "Минимальная ставка",
    "currency.maxPay": "Максимальная выплата",
    "currency.chips": "Фишки (пишите через запятую)",
    "currency.maxPP": "Максимальная PERFECT PAIR",
    "currency.max21": "Максимальная 21+3",
    "currency.maxBust": "Максимальная BUST",
    "currency.maxCS": "Максимальная CRAZY SEVEN",
    "currency.maxBetShort": "Макс. ставка",
    "currency.minBetShort": "Мин. ставка",
    "currency.maxPayShort": "Макс. выплата",
    "currency.chipsLabel": "Фишки",
    "currency.create": "Создать",
    "currency.enterCurrency": "Выберите валюту",
    "currency.enterMaxBet": "Введите максимальную ставку",
    "currency.enterMaxPP": "Введите максимальную PERFECT PAIR",
    "currency.enterMax21": "Введите максимальную 21+3",
    "currency.enterMaxBust": "Введите максимальную BUST",
    "currency.enterMaxCS": "Введите максимальную CRAZY SEVEN",
    "currency.enterMinBet": "Введите минимальную ставку",
    "currency.enterMaxPay": "Введите максимальную выплату",
    "currency.enterChips": "Введите список фишек",

    /* Card pages */
    "card.title": "Карты",
    "card.name": "Название",
    "card.image": "Изображение",
    "card.value": "Значение",
    "card.editBarcode": "Изменить BARCODE",
    "card.editTitle": "Изменить Barcode",
    "card.error.emptyBarcode": "Введите Barcode",
    "card.barcode": "Barcode",
    "card.savedSuccess": "Barcode успешно сохранен",

    /* Role pages */
    "role.title": "Роли",
    "role.name": "Название",
    "role.accessCount": "Количество доступов",
    "role.add": "Добавить",
    "role.edit": "Редактировать",
    "role.delete": "Удалить",
    "role.addTitle": "Добавить роль",
    "role.editTitle": "Редактировать роль",
    "role.accessTo": "Доступы к",
    "role.error.emptyName": "Введите название роли",
    "role.addedSuccess": "Роль успешно добавлена",
    "role.savedSuccess": "Роль успешно сохранена",
    "role.deletedSuccess": "Роль успешно удалена",

    /* Operator pages */
    "operator.title": "Операторы",
    "operator.name": "Имя",
    "operator.changeAccess": "Изменить доступы",
    "operator.edit": "Редактировать",
    "operator.delete": "Удалить",
    "operator.createTitle": "Создать оператора",
    "operator.editTitle": "Редактировать оператора",
    "operator.changeAccessTitle": "Изменить доступы для",
    "operator.error.emptyName": "Введите свое имя",
    "operator.error.emptySlug": "Введите slug",
    "operator.error.emptySlugAlt": "Введите Slug",
    "operator.error.emptyStartpoint": "Введите Startpoint",
    "operator.error.emptyBalance": "Введите Balance URL",
    "operator.error.emptyDebit": "Введите Debit URL",
    "operator.error.emptyCredit": "Введите Credit URL",
    "operator.error.emptyWebhook": "Введите Webhook URL",
    "operator.addedSuccess": "Оператор успешно добавлен",
    "operator.savedSuccess": "Оператор успешно изменен",
    "operator.deletedSuccess": "Пользователь успешно удален",

    /* Bonus page */
    "bonus.notFound": "По вашему запросу ничего не найдено",
    "bonus.operator": "Оператор",
    "bonus.game": "Игра",
    "bonus.player": "Игрок",
    "bonus.bet": "Ставка",
    "bonus.win": "Выигрыш",
    "bonus.date": "Дата",
    "bonus.info": "Информация",
    "bonus.number": "Номер",
    "bonus.gameNumber": "Номер игры #",
    "bonus.exchangeRate": "Курс валют (к доллару США)",
    "bonus.combination": "Комбинация",
    "bonus.multiplier": "Умножитель",
    "bonus.cash": "Касса",
    "bonus.filter": "Фильтр",
    "bonus.operators": "Операторы",
    "bonus.search": "Поиск по номеру игры или по коду игрока",
    "bonus.title": "Бонус",
    "bonus.settings": "Настройки",
    "bonus.games": "Игры",
    "bonus.reset": "Сбросить",
    "bonus.jackpotNotConnected": "не подключен",
    "bonus.connectJackpot": "Подключите ДЖЕКПОТ к оператору",
    "bonus.connect": "Подключить",
    "bonus.cashRegister": "КАССА",
    "bonus.active": "Активен",
    "bonus.disabled": "Отключен",
    "bonus.jackpotSettings": "Настройки JACKPOT",

    /* Studio pages */
    "studio.title": "Cтудии",
    "studio.name": "Название",
    "studio.code": "Код",
    "studio.token": "Токен",
    "studio.edit": "Редактировать",
    "studio.delete": "Удалить",
    "studio.add": "Добавить",
    "studio.deleteConfirm": "Вы действительно хотите удалить студию?",
    "studio.deleteWarning": "Невозможно восстановить после изменений",
    "studio.deleteButton": "Да, удалить",
    "studio.deletedSuccess": "Cтудия успешно удалена!",
    "studio.createdTitle": "Cоздать студию",
    "studio.editTitle": "Редактировать",
    "studio.savedSuccess": "Данные успешно сохранены!",
    "studio.nameLabel": "Название",
    "studio.codeLabel": "Код",
    "studio.error.emptyName": "Введите название",
    "studio.error.emptyCode": "Введите код",
    "studio.error.emptyServiceURL": "Введите Service URL",
    "studio.error.emptySocketURL": "Введите Socket URL",
    "studio.createdSuccess": "Студия успешно создана!",

    /* Studio stream */
    "studio.streams": "Стримы",
    "studio.participants": "Участники",
    "studio.video": "Видео",
    "studio.audio": "Аудио",
    "studio.allTime": "За все время",
    "studio.load": "Загруженность",
    "studio.yes": "Да",
    "studio.no": "Нет",

    /* Studio room (stream control) */
    "studio.disableStreamTitle": "Отключить стрим?",
    "studio.disableStreamText": "Вы действительно хотите отключить стрим?",
    "studio.disableStreamButton": "Отключить",
    "studio.disabledSuccess": "Успешно отключено!",

    /* Message page */
    "message.title": "Сообщение",
    "message.player": "Игрок",
    "message.game": "Игра",
    "message.text": "Сообщение",
    "message.dateTime": "Дата и время",

    /* Notification page */
    "notification.title": "Уведомление",
    "notification.table": "Стол",
    "notification.notification": "Уведомление",
    "notification.dateTime": "Дата и время",
    "notification.new": "Новый",
    "notification.go": "Перейти",

    /* Support chat */
    "support.title": "Cлужба поддержки",
    "support.inputPlaceholder": "Введите сообщение...",
    "support.playerType": "Игрок",
    "support.adminType": "Админ",
    "support.noMessages": "Здесь пока нет сообщений",
    "support.noMessagesDesc": "В службу поддержки ещё не обращался",
    "support.messageSent": "Сообщение успешно отправлено",
    "support.emptyMessage": "Введите сообщение",
    "support.messagePlaceholder": "Сообщение",

    /* Table / Control widget */
    "table.bridgeConnected": "Подключено к Bridge",
    "table.bridgeError": "Ошибка Bridge",
    "table.noGameConnection": "Нет подключение с игрой!",
    "table.save": "Сохранить",
    "table.visibility": "Видимость стола",
    "table.visibilityDesc": "Сделайте стол публичным или скрытым",
    "table.free": "Стол свободен",
    "table.busy": "Стол занят",
    "table.autoDetected": "Определяется автоматический",
    "table.access": "Доступ к столу (открыть/закрыть смену)",
    "table.accessDesc": "Разрешить или запретить вход на стол",
    "table.closed": "Cтол закрыт",
    "table.working": "Cтол работает",
    "table.allDay": "Круглосуточно",
    "table.allDayDesc": "Круглосуточная работа",
    "table.startTime": "Время начала работы",
    "table.endTime": "Время окончания работы",
    "table.error.emptyStart": "Введите время",
    "table.error.emptyEnd": "Введите время",
    "table.deleteConfirm": "Удалить игру?",
    "table.deleteWarning": "После удаления восстановить невозможно.",
    "table.deleteCancel": "Отменить",
    "table.deleteButton": "Удалить",
    "table.deletedSuccess": "Игра удалена!",

    /* Table / Dealer widget */
    "table.dealerAdded": "Дилер добавлен",
    "table.dealerRemoved": "Дилер убран",

    /* Table / Refunds */
    "table.refundTxNumber": "Номер транзакции",
    "table.refundName": "Название",
    "table.refundAmount": "Сумма",
    "table.refundAmountUSD": "Сумма (USD)",
    "table.refundStatus": "Статус",
    "table.refundAdmin": "Админ",
    "table.refundDateTime": "Дата и время",
    "table.refundSuccess": "Успешно",

    /* Bonus widgets */
    "jackpot.notConnected": "JACKPOT не подключен",
    "jackpot.connectDesc": "Подключите ДЖЕКПОТ к оператору",
    "jackpot.connect": "Подключить",
    "jackpot.cash": "КАССА",
    "jackpot.active": "Активен",
    "jackpot.disabled": "Отключен",
    "jackpot.settings": "Настройки JACKPOT",
    "jackpot.selectOperator": "Выберите оператора",
    "jackpot.cashLabel": "Касса, $",
    "jackpot.visibility": "Видимость",
    "jackpot.connectButton": "Соединить",

    /* Timezone */
    "timezone.title": "Выберите часовой пояс",
    "timezone.confirmTitle": "Ваш часовой пояс",
    "timezone.confirmText": "Определён по вашему устройству. Верно?",
    "timezone.yes": "Да, верно",
    "timezone.change": "Изменить",

}

export default ru
